import React, { useState } from "react";
import { Button, Drawer, Form, Input, message } from "antd";
import axiosConfig from "../../../util/axiosConfig";
import TextArea from "antd/es/input/TextArea";
import requestErrorHandler from "../../../util/requestErrorHandler";

const AddPartner = ({ getPartners }: any) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  async function handleSubmit() {
    setIsLoading(true);
    await axiosConfig
      .post("/partner/create", form.getFieldsValue())
      .then((response: any) => {
        message.success("Partner added successfully");
        form.resetFields();
        setOpen(false);
        getPartners();
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(true);
      });
  }

  return (
    <>
      <Button
        type="primary"
        className="bg-[#096DD9]"
        onClick={() => setOpen(true)}
      >
        Add Partner
      </Button>
      <Drawer
        title="Add Partner"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Form
          className="w-100"
          onFinish={handleSubmit}
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="businessName"
            label="Business name"
            rules={[{ required: true, message: "Enter a valid name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Enter a valid email" },
              { type: "email" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="businessAddress"
            label="Business address"
            rules={[{ required: true, message: "Enter a valid address" }]}
          >
            <TextArea />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={isLoading}
            className="bg-[#096DD9]"
          >
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default AddPartner;
